"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useState } from "react";
import { formatter } from "@/lib/formatter";
interface ClientStartEndDateProps {
  openingTime: string;
  closingTime: string;
}
function ClientStartEndDate(t0) {
  const $ = _c(9);
  const {
    openingTime,
    closingTime
  } = t0;
  const [isHydrated, setIsHydrated] = useState(false);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setIsHydrated(true);
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  if (!isHydrated) {
    return "Chargement...";
  }
  let t3;
  if ($[2] !== openingTime) {
    t3 = formatter.getTime(openingTime);
    $[2] = openingTime;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== closingTime) {
    t4 = formatter.getTime(closingTime);
    $[4] = closingTime;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3 || $[7] !== t4) {
    t5 = <><span>{t3} - {t4}</span></>;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
}
export default ClientStartEndDate;